'use strict';

import { IScope } from "angular";
import { AlarmMonitorAddressbookResponse } from "../../../../data/am4.data";
import { AMobile, AMobileAddressbookResponse } from "../../../../data/amobile.data";
import RestService from "../../../../services/rest.service";
import { SortParams } from "../../../views/addressbook.view.component/addressbook.view.component";

require('./amobile.base.field.css');

export default class AmobileBaseFieldComponent {
  public restrict: any;
  public template: any;
  public scope: any;
  public controller: any;
  public controllerAs: any;
  public bindToController: any;

  constructor() {
    this.restrict = 'E';
    this.template = require('./amobile.base.field.html');
    this.scope = {
      field: '=',
      isDerivedFromTemplate: '='
    };
    this.controller = AmobileBaseFieldController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}


/* @ngInject */
class AmobileBaseFieldController {
  public field: any;
  public aMobiles: AMobileAddressbookResponse;
  public restService: RestService;
  public $scope: IScope;
  public isLoading = false;
  private params = {
    currentPage: 0,
    totalElements: 0,
    pageSize: 20
  } as SortParams;

  constructor(restService: RestService, $scope: IScope) {
    this.restService = restService;
    this.$scope = $scope;
    this.pageChanged();
  }
  /**
   * Returns true, if the aMobile is selected
   * @param {amobile} am
   */
  isSelected(aMobile: AMobile) {
    for (var i = 0; i < this.field.value.length; i++) {
      if (this.field.value[i] === aMobile.id) {
        return true;
      }
    }
    return false;
  }

  /**
   * Select the given aMobile
   * @param {amobile} am
   */
  select(aMobile: AMobile) {
    if (this.isSelected(aMobile)) {
      //Remove
      var indexToDelete = -1;
      for (var i = 0; i < this.field.value.length; i++) {
        if (this.field.value[i] === aMobile.id) {
          indexToDelete = i;
          break;
        }
      }
      if (indexToDelete > -1) {
        this.field.value.splice(indexToDelete, 1);
      }
    } else {
      //Add
      this.field.value.push(aMobile.id);
    }
  }


  pageChanged() {
    return new Promise<void>((resolve, reject) => {
      this.isLoading = true;
      this.restService.loadAMobilesForBaseField(this.params.currentPage === 0 ? 0 : this.params.currentPage - 1, this.params.pageSize)
        .then((result: AMobileAddressbookResponse) => {
          this.aMobiles = result;
          this.params.totalElements = this.aMobiles.totalElements;
          this.params.totalPages = this.aMobiles.totalPages;
        }).finally(() => {
          this.isLoading = false;
          this.$scope.$applyAsync();
          resolve();
        });
    });
  }
}
